
<div mat-dialog-content class="dialog-container dialog-{{type}}">
    <h4 class="dialog-title">{{title}}</h4>
    <p class="dialog-message">{{ message }}</p>
    <div [ngSwitch]="type">
        <div mat-dialog-actions *ngSwitchCase="'confirmation'">
            <button type="button" 
                mat-raised-button color="primare"
                (click)="dialogRef.close(type)">OK</button>
            <button 
                mat-raised-button color="accent"
                type="button"
                (click)="dialogRef.close()">Cancel</button>
        </div>
        <div mat-dialog-actions *ngSwitchCase="'alert'">
            <button type="button" mat-raised-button color="accent" 
                (click)="dialogRef.close()">OK</button>
        </div>
    </div>   
       
</div>